export const SettingsResource = {
  name: "Settings",
  description: "Sales Settings management module",
  path: "sales/settings",
  icon: "bi bi-bag",
  access: ["read-customers", "read-customergroups"],
  children: [],
};
